import React from 'react';
import { Field, Form, FormController } from 'core/cells/forms';
import { FormTextField } from 'core/cells/form-text-field';
import { FlexBox } from 'core/cells/box';

import { Button } from 'templates/mdp/components/custom-buttons';

import { JournalType } from 'core/dna/types/generated/_globalTypes';
import { useTranslations } from 'core/dna/translations';
import { mapTimeStringToDateTime } from 'core/atoms/functions/string';
import { useStudentsTableWrite } from '../use-students-table-write';

interface Values {
  from: string;
  info: string;
}

interface JournalDiaperProps {
  tuid: string | null;
  setOpen: (open: boolean) => void;
  resetJournalType: (selectedType: JournalType | null) => void;
}

export const JournalDiaper = ({
  tuid,
  setOpen,
  resetJournalType,
}: JournalDiaperProps) => {
  const { texts } = useTranslations();
  const { onCreateJournalEntry } = useStudentsTableWrite();

  return (
    <FormController
      initialValues={{
        from: '',
        info: '',
      }}
      validate={(values) => {
        const errors: Partial<Values> = {};
        if (!values.from) {
          errors.from = texts.oasCommon.validation.required;
        }
        return errors;
      }}
      onSubmit={async (values) => {
        if (!tuid) return;
        await onCreateJournalEntry({
          regardingTuid: tuid,
          type: JournalType.diaper,
          data: {
            [JournalType.diaper]: values.info,
          },
          from: mapTimeStringToDateTime(values.from),
        });
        setOpen(false);
        resetJournalType(null);
      }}
    >
      {({ submitForm, isSubmitting }) => (
        <Form>
          <Field
            component={FormTextField}
            name="from"
            type="time"
            label={texts.planner.common.from}
            disabled={isSubmitting}
            fullWidth
            InputLabelProps={{ shrink: true }}
          />
          <Field
            component={FormTextField}
            name="info"
            type="text"
            label={texts.studentModule.journal.optionalInfo}
            disabled={isSubmitting}
            fullWidth
          />
          <FlexBox justifyContent="flex-end">
            <Button
              color="secondary"
              disabled={isSubmitting}
              onClick={submitForm}
            >
              {texts.planner.common.save}
            </Button>
            <Button
              color="secondary"
              simple
              onClick={() => {
                setOpen(false);
              }}
            >
              {texts.planner.common.close}
            </Button>
          </FlexBox>
        </Form>
      )}
    </FormController>
  );
};
